<template>
  <v-card class="overflow-hidden v-card v-sheet theme--light px-1 py-3 m-0">
    <!-- alert message -->
    <div>
      <v-alert :type="alert_type" :model-value="alert" :value="alert" transition="scale-transition">{{ alert_message }}</v-alert>
    </div>
    <!-- alert message end -->
    <!-- header -->
    <div>
      <HeaderComponent :headerTitle="headerText" />
    </div>
    <!-- header end -->
    <!-- tabs -->
    <v-card class="v-card-100">
      <v-tabs v-model="selected_tab">
        <div>
          <v-menu offset-y>
            <template v-slot:activator="{ props }">
              <v-tab class="component-tab-heading tab-color" v-bind="props" style="text-transform:none; padding: 0px 0px !important" color="primary">
              <span style="width: 300px !important; padding: 12px 0px;">{{ selectedCreateLotSubtab }}
                <v-icon>{{ createLotDropDown ? 'mdi-menu-up' : 'mdi-menu-down' }}</v-icon></span>
              </v-tab>
            </template>
            <v-list>
              <v-list-item v-for="subtab in createLotSubTab" :key="subtab">
                <v-list-item-title
                :class="{ 'disabled-tab': subtab === selectedCreateLotSubtab || isDisabledSubtab(subtab) }"
                @click="loadData(subtab, 'subtab_clicked1', index)"
                style="cursor: pointer;">
                {{ subtab }}
              </v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
        </div>
        <v-tab style="text-transform:none!important;" @click="loadData(tab, 'tab_clicked')" v-for="(tab, index) in tabs2" :key="index" color="primary" class="component-tab-heading tab-color">{{ tab }}</v-tab>
      </v-tabs>
    </v-card>
    <!-- tabs end -->
    <!-- popups -->
    <!-- short quantity popup-->
    <!-- <v-row justify="center">
      <v-dialog v-model="shortQuantityReceivedPopup" persistent max-width="1100px">
        <v-card class="v-card-100">
          <v-card class="v-card-100">
            <v-card-title>
              <v-row>
                <v-col cols="3">
                  <span style="font-size:14px;">Raise Claim</span>
                </v-col>
                <v-col cols="3">
                  <span style="font-size:12px;">IRD No:     {{ selected && selected.length > 0 ? selected[0].ird_number : ''}}</span>
                </v-col>
                <v-col cols="3">
                  <span style="font-size:12px;">QTY As Per IRD:     {{ selected && selected.length > 0 ? selected[0].ird_quantity : '' }} </span>
                </v-col>
                <v-col cols="3">
                  <span style="font-size:12px;">Short Qty:      {{ selected && selected.length > 0 ? selected[0].short_quantity : '' }} </span>
                </v-col>
              </v-row>
              <v-spacer></v-spacer>
              <v-btn variant="solo" icon @click="shortQuantityReceivedPopup = false">
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-card-title>
          </v-card>
          <v-container style="overflow:scroll;">
            <v-row>
              <v-col cols="12" sm="6" md="12" class="pa-0 pb-3">
                  <v-data-table 
                  :dense="true" 
                  :search="search" 
                  v-model:selected="selected"
                  disable-pagination 
                  :hide-default-footer="true"
                  :headers="shortQtyHeader" 
                  :items="short_qty_items"
                  :item-value="id"
                  :loading="loading"
                  loading-text="Loading Data... Please wait"
                  class="elevation-1 v-data-simple-adjust">
                  <template v-slot:item.claim_amount="{ item }">
                    <v-text-field small variant="outlined" class="p-2" label="Claim Amount(₹)*" :rules="[claimAmountRule(item)]" :value="item.claim_amount" v-model="item.claim_amount" hide-details dense @input="formatClaimAmount($event, item)"></v-text-field>
                  </template>
                  <template v-slot:item.update_vendor_code="{ item }">
                    <v-text-field small class="p-2" label="Update the vendor code*" variant="outlined" v-model="item.update_vendor_code" hide-details dense></v-text-field>
                  </template>
                  <template v-slot:item.map="{ item }">
                    <span>₹{{ item.map ? item.map.toLocaleString('en-IN') : '-' }}</span>
                  </template>
                </v-data-table>
              </v-col>
            </v-row>
          </v-container>
          <v-card-actions style="justify-content: center;">
            <v-btn small variant="outlined" color="normal"  class="mb-3 text-none" @click="shortQuantityReceivedPopup = false">Cancel</v-btn>
            <v-btn small variant="flat" color="primary" class="mb-3 text-none" :disabled="!isFormValid || loading" @click="RaiseClaim">
              <template v-if="loading">
                <v-progress-circular indeterminate size="20" color="white"></v-progress-circular>
              </template>
              <template v-else>
                Submit
              </template>
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row> -->
    <v-row justify="center">
      <v-dialog v-model="shortQuantityReceivedPopup" persistent max-width="1100px">
        <v-card class="v-card-100">
          <v-card class="v-card-100">
            <v-card-title>
              <v-row class="ma-1 mt-0"  v-if="active_tab !== 'Write Off Items'">
              <v-row>
                <v-col cols="3">
                  <span style="font-size:16px;">Raise Claim</span>
                </v-col>
                <v-col cols="3">
                  <span style="font-size:16px;">IRD No:     {{ selected && selected.length > 0 ? selected[0].ird_number : ''}}</span>
                </v-col>
                <v-col cols="3">
                  <span style="font-size:16px;">QTY As Per IRD:     {{ selected && selected.length > 0 ? selected[0].ird_quantity : '' }} </span>
                </v-col>
                <v-col cols="3">
                  <span style="font-size:16px;">Short Qty:      {{ selected && selected.length > 0 ? selected[0].short_quantity : '' }} </span>
                </v-col>
              </v-row>
              <span v-if="active_tab === 'Write Off Items'">Raise Claim</span>
              <v-spacer></v-spacer>
              <!-- <v-btn icon @click="shortQuantityReceivedPopup = false"> -->
                <v-icon @click="shortQuantityReceivedPopup = false">mdi-close</v-icon>
              <!-- </v-btn> -->
            </v-row>
            </v-card-title>
          </v-card>
          <v-container style="overflow:scroll;">
            <v-row>
              <v-col cols="12" sm="6" md="12" class="pa-0 pb-3">
                  <v-data-table 
                  :dense="true" 
                  :search="search" 
                  v-model="selected" 
                  disable-pagination 
                  :hide-default-footer="true"
                  :headers="shortQtyHeader" 
                  :items="short_qty_items"
                  :item-value="id"
                  :loading="loading"
                  loading-text="Loading Data... Please wait"
                  class="elevation-1 v-data-simple-adjust">
                  <template v-slot:item.claim_amount="{ item }">
                    <v-text-field small variant="outlined" class="p-2" :label="active_tab === 'Write Off Items' ? 'Short Quantity Amount (₹)' : 'Claim Amount(₹)*'" :value="item.claim_amount" v-model="item.claim_amount" hide-details dense @input="formatClaimAmount($event, item)"></v-text-field>
                    <!-- <v-text-field small variant="outlined" class="p-2" label="Claim Amount(₹)*" :rules="[claimAmountRule(item)]" :value="item.claim_amount" v-model="item.claim_amount" hide-details dense @input="formatClaimAmount($event, item)"></v-text-field> -->
                  </template>
                  <template v-slot:item.update_vendor_code="{ item }">
                    <v-autocomplete small dense class="mt-6" v-model="item.update_vendor_code" :items="update_vendor_items" item-value="id" item-text="value" label="Select Vendor" variant="outlined"></v-autocomplete>
                    <!-- <v-text-field small class="p-2" label="Update the vendor code*" variant="outlined" v-model="item.update_vendor_code" hide-details dense></v-text-field> -->
                  </template>
                  <template v-slot:item.claim_tracking_number="{ item }">
                    <v-text-field small variant="outlined" class="p-2" label="Claim Tracking No." :value="item.claim_tracking_number" v-model="item.claim_tracking_number" hide-details dense></v-text-field>
                  </template>
                  <template v-slot:item.map="{ item }">
                    <span>₹{{ item.map ? item.map.toLocaleString('en-IN') : '-' }}</span>
                  </template>
                  <template #[`item.sku_description`]="{ item }">
                      <v-tooltip location="bottom">
                        <template v-slot:activator="{ props }">
                          <span v-bind="props" v-on="on">
                            {{ item.sku_description.substring(0, 10) + '...' }}
                          </span>
                        </template>
                        <span style="white-space: nowrap;">{{ item.sku_description }}</span>
                      </v-tooltip>
                    </template>
                    <template #[`item.article_description`]="{ item }">
                      <v-tooltip location="bottom">
                        <template v-slot:activator="{ props }">
                          <span v-bind="props" v-on="on">
                            {{ item.article_description.substring(0, 10) + '...' }}
                          </span>
                        </template>
                        <span style="white-space: nowrap;">{{ item.article_description }}</span>
                      </v-tooltip>
                    </template>
                  <template #bottom></template>
                </v-data-table>
              </v-col>
            </v-row>
          </v-container>
          <v-card-actions style="justify-content: center;">
            <v-btn small color="normal" variant="outlined"  class="mb-3 text-none" @click="shortQuantityReceivedPopup = false">Cancel</v-btn>
            <v-btn small variant="flat" color="primary" class="mb-3 text-none" :disabled="!isFormValid || loading" @click="RaiseClaim">
              <template v-if="loading">
                <v-progress-circular indeterminate size="20" color="white"></v-progress-circular>
              </template>
              <template v-else>
                Submit
              </template>
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>

    <!-- Short Item raise claim popup-->
    <v-row justify="center">
      <v-dialog v-model="ShortItemRaiseClaimPopup" persistent max-width="350px">
        <v-card class="v-card-100">
          <v-card class="v-card-100">
            <v-card-title class="d-flex">
              <v-row class="ma-1 mt-0">
                <span>Raise Claim</span>
                <v-spacer></v-spacer>
                <!-- <v-btn variant="solo" icon > -->
                  <v-icon @click="ShortItemRaiseClaimPopup = false">mdi-close</v-icon>
                <!-- </v-btn> -->
              </v-row>
            </v-card-title>
          </v-card>
          <v-container>
            <v-row class="text-center">
              <v-col>
                <span>Are you sure you want to raise the claim?</span>
              </v-col>
            </v-row> 
          </v-container>
          <v-card-actions style="justify-content: center;">
            <v-btn small variant="outlined" color="normal"  class="mb-3 text-none" @click="ShortItemRaiseClaimPopup = false">No</v-btn>
            <v-btn small variant="flat" color="primary" class="mb-3 text-none" @click="RaiseClaim">Yes</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>
    <!-- raise claim  -->
    <v-row justify="center">
      <v-dialog v-model="RaiseClaimPopup" persistent max-width="700px">
        <v-card class="v-card-100">
          <v-card-title class="d-flex align-center">
            <span>Raise Claim</span>
            <v-spacer></v-spacer>
            <v-btn variant="solo" icon @click="RaiseClaimPopup = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-card-title>
          <v-divider :thickness="4" class="m-0" />
          <v-container>
            <v-row>
              <v-col>
                <v-text-field label="Update The Amount (₹)" outlined v-model="formattedUpdateAmount" oninput="this.value = this.value.replace(/[^0-9,]/g, '');"> </v-text-field>
              </v-col>
              <v-col>
                <v-text-field label="Claim Number" outlined v-model="claimNumber" type="number" :min="0" > </v-text-field>
              </v-col>
            </v-row> 
          </v-container>
          <v-card-actions style="justify-content: center;">
            <v-btn small color="primary" variant="flat" class="mb-3 text-none" :disabled="!updateAmount || !claimNumber || number>0" @click="ecomMarSubmit">Submit</v-btn>
            <v-btn small color="normal" variant="outlined"  class="mb-3 text-none" @click="RaiseClaimPopup = false">Cancel</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>
    <!-- logistic raise claim -->
    <v-row justify="center">
      <v-dialog v-model="logisticRaiseClaimPopup" persistent max-width="350px">
        <v-card class="v-card-100">
          <v-card-title class="d-flex align-center">
            <span>Raise Claim</span>
            <v-spacer></v-spacer>
            <v-btn variant="solo" icon @click="logisticRaiseClaimPopup = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-card-title>
          <v-divider :thickness="4" class="m-0" />
          <v-container>
            <v-text-field label="Update The Amount (₹)" outlined v-model="formattedUpdateAmount" oninput="this.value = this.value.replace(/[^0-9,]/g, '');"> </v-text-field>
          </v-container>
          <v-card-actions style="justify-content: center;">
            <v-btn small color="primary" variant="flat" class="mb-3 text-none" :disabled="!updateAmount || number>0" @click="SubmitRaiseClaim">Submit</v-btn>
            <v-btn small color="normal"  variant="outlined" class="mb-3 text-none" @click="logisticRaiseClaimPopup = false">Cancel</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>
    <v-row justify="center">
      <v-dialog v-model="conditionMismatchPopup" persistent max-width="1000px">
        <v-card class="v-card-100">
          <v-card-title class="d-flex align-center">
            <span>Raise Claim</span>
            <v-spacer></v-spacer>
            <v-btn variant="solo" icon @click="conditionMismatchPopup = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-card-title>
          <v-divider :thickness="4" class="m-0" />
          <v-container style="overflow:scroll;">
            <v-row>
              <v-col cols="12" sm="6" md="12" class="pa-0 pb-3">
                  <v-data-table 
                  :dense="true" 
                  :search="search" 
                  v-model="selected" 
                  disable-pagination 
                  :hide-default-footer="true"
                  :headers="shortQtyHeader" 
                  :items="short_qty_items"
                  :item-value="id"
                  :loading="loading"
                  loading-text="Loading Data... Please wait"
                  class="elevation-1 v-data-simple-adjust">
                  <template #[`item.claim_amount`]="{ item }" >
                    <v-text-field small variant="outlined" class="p-2" :label="active_tab === 'Write Off Items' ? 'Short Quantity Amount (₹)' : 'Claim Amount(₹)*'" :value="item.claim_amount" v-model="item.claim_amount" hide-details dense @input="formatClaimAmount($event, item)"></v-text-field>
                  </template>
                  <template #[`item.update_vendor_code`]="{ item }" >
                  <v-autocomplete small variant="outlined" class="mt-6" v-model="item.update_vendor_code" :items="update_vendor_items" item-value="id" item-text="value" label="Select Vendor" outlined></v-autocomplete>
                  </template>
                  <template v-slot:item.claim_tracking_number="{ item }">
                    <v-text-field small variant="outlined" class="p-2" label="Claim Tracking No." :value="item.claim_tracking_number" v-model="item.claim_tracking_number" hide-details dense></v-text-field>
                  </template>
                  <template #[`item.sku_description`]="{ item }">
                      <v-tooltip location="bottom">
                        <template v-slot:activator="{ props }">
                          <span v-bind="props" v-on="on">
                            {{ item.sku_description.substring(0, 10) + '...' }}
                          </span>
                        </template>
                        <span style="white-space: nowrap;">{{ item.sku_description }}</span>
                      </v-tooltip>
                    </template>
                  <template #[`item.map`]="{ item }">
                    <span>₹{{ item.map ? item.map.toLocaleString('en-IN') : '-' }}</span>
                  </template>
                </v-data-table>
              </v-col>
            </v-row>
          </v-container>
          <v-card-actions style="justify-content: center;">
           <v-btn variant="outlined" small color="normal"  class="mb-3 text-none" @click="conditionMismatchPopup = false">Cancel</v-btn>
            <v-btn small color="primary" variant="flat" class="mb-3 text-none" :disabled="!isFormValid || number>0" @click="mismatchSubmit">Submit</v-btn>            
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>
    <!-- update claim popup -->
    <v-row justify="center">
      <v-dialog v-model="updateClaimPopup" persistent max-width="700px">
        <v-card class="v-card-100">
          <v-card-title class="d-flex align-center">
            <span>Update Claim</span>
            <v-spacer></v-spacer>
            <v-btn variant="solo" icon @click="updateClaimPopup = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-card-title>
          <v-divider :thickness="4" class="m-0" />
          <v-container>
            <v-row class="mr-2 ml-2">
              <v-radio-group row v-model="approveReject">
                  <v-radio  label="Approve" value="Approve" style="margin-right: 265px;" ></v-radio>
                  <v-radio  label="Reject" value="Reject"></v-radio>
              </v-radio-group>
            </v-row>
            <v-row>
              <v-col cols="6" sm="6" md="6">
                <v-text-field v-model="creditNoteAmount" label="Approved/Credit Note Amount" outlined  type="number" :disabled="isRejectSelected"> </v-text-field>
              </v-col>
              <v-col cols="6" sm="6" md="6">
                <v-text-field v-model="ApprovalNumber" label="Approval Number" outlined  type="number" :disabled="isRejectSelected"> </v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" sm="12" md="12">
                <v-textarea v-model="Remarks" label="Remarks" outlined ></v-textarea>
              </v-col>
            </v-row>
          </v-container>
          <v-card-actions style="justify-content: center;">
            <v-btn small variant="flat" color="primary" class="mb-3 text-none" :disabled="number>0" @click="SubmitUpdateClaim">Submit</v-btn>
            <v-btn small variant="outlined" color="normal"  class="mb-3 text-none" @click="updateClaimPopup = false">Cancel</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>
    <!--  -->
    <v-row justify="center">
      <v-dialog v-model="viewDetailsPopup" persistent max-width="800px">
        <v-card class="v-card-100">
          <v-card class="v-card-100 custom-shadow ma-0">
            <v-card-title class="pa-0">              
                <v-row class="ma-2">
                  <span class="font-weight-bold">{{ id }}</span>
                  <v-spacer></v-spacer>
                    <v-icon @click="viewDetailsPopup = false">mdi-close</v-icon>
                </v-row>              
            </v-card-title>
            </v-card>
          <v-container>
            <v-row>
              <v-col cols="12" sm="6" md="12" class="pa-0 pb-3">
                  <v-data-table 
                  :dense="true" 
                  :search="search" 
                  v-model="selected" 
                  disable-pagination 
                  :hide-default-footer="true"
                  :headers="viewDetailsHeader" 
                  :items="condition_mismatch_items" 
                  :loading="loading" 
                  :show-expand="active_tab === 'For Short Quantity Received'"
                  loading-text="Loading Data... Please wait"
                  class="elevation-1 v-data-simple-adjust">
                  <template v-slot:[`item.${headers.key}`]="{ item }" v-for="headers in viewDetailsHeader">
                      <span v-if="headers.key == 'test'">
                        <span>{{ item.test ? item.test : "-" }}</span>
                      </span>                       
                      <span v-else-if="item[headers.key]">
                        <GlobalTooltip :text="item[headers.key]" />
                        </span>
                        <span v-else>-</span>
                    </template>                     
                     <template v-slot:item['data-table-expand']="{ internalItem, isExpanded, toggleExpand }">
                              <v-icon @click="toggleExpand(internalItem)">{{ isExpanded(internalItem) ? 'mdi-chevron-up' : 'mdi-chevron-down' }}</v-icon>
                          </template>
                          <template #expanded-row="{ item }">
                            <tr>
                              <td colspan="9">
                                <v-data-table 
                                :dense="true"
                                disable-pagination 
                                :hide-default-footer="true"
                                :headers="viewDetailsSubHeader" 
                                :items="item.claim_details" 
                                :loading="loading" 
                                loading-text="Loading Data... Please wait"
                                class="elevation-1 v-data-simple-adjust"
                                ></v-data-table>
                              </td>
                          </tr>
                        </template>
                  <template #bottom></template>
                </v-data-table>
              </v-col>
            </v-row>
          </v-container>
        </v-card>
      </v-dialog>
    </v-row>
      <!-- pending resolution tab popup -->
      <v-dialog v-model="resolutionItemDetailPopup" persistent max-width="800px">
        <v-card class="v-card-100">
          <v-card-title class="d-flex align-center">
            <span>Item Details<br><span class="itemIDS">Tad ID : {{ item_id }}</span></span>
            <v-spacer></v-spacer>
            <v-btn variant="solo" icon @click="resolutionItemDetailPopup = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-card-title>
          <v-divider :thickness="4" class="m-0" />
          <v-container style="width: 95%;">
            <table class="w-100">
              <tbody>

              <tr >
                <th class="itemDetailHeader col-4 sm-4">Lot Description</th>
                <td class="ItemDetailContent col-6 sm-6">{{view_details.item_description || '-' }}</td>
              </tr>
              <!-- <tr>
                <th class="itemDetailHeader col-4 sm-4">Lot Category</th>
                <td class="ItemDetailContent col-6 sm-6">{{view_details.}}</td>
              </tr>
              <tr>
                <th class="itemDetailHeader col-4 sm-4">Lot ID</th>
                <td class="ItemDetailContent col-6 sm-6">{{view_details}}</td>
              </tr> -->
              <tr>
                <th class="itemDetailHeader col-4 sm-4">Return Reason</th>
                <td class="ItemDetailContent col-6 sm-6">{{view_details.return_reason || '-' }}</td>
              </tr>
              <tr>
                <th class="itemDetailHeader col-4 sm-4">Remark</th>
                <td class="ItemDetailContent col-6 sm-6">
                  {{ view_details.remarks || '-' }}
                  <span v-if="view_details.remarks" class="editRemarks" @click="openRemark">Edit</span>
                </td>
              </tr>
              <tr>
                <th class="itemDetailHeader col-4 sm-4">Channel</th>
                <td class="ItemDetailContent col-6 sm-6">{{view_details.channel || '-' }}</td>
              </tr>
              <tr>
                <th class="itemDetailHeader col-4 sm-4">Article ID</th>
                <td class="ItemDetailContent col-6 sm-6">{{view_details.sku_code || '-' }}</td>
              </tr>
              <tr>
                <th class="itemDetailHeader col-4 sm-4">Serial Number</th>
                <td class="ItemDetailContent col-6 sm-6">{{view_details.serial_number || '-' }}</td>
              </tr>
              <tr>
                <th class="itemDetailHeader col-4 sm-4">Price</th>
                <td class="ItemDetailContent col-6 sm-6">{{view_details.item_price || '-' }}</td>
              </tr>
              <tr>
                <th class="itemDetailHeader col-4 sm-4">Document</th>
                <td class="ItemDetailContent col-6 sm-6">{{'-' }}</td>
              </tr>
              <tr>
                <th class="itemDetailHeader col-4 sm-4">Images</th>
                <td v-if="view_details.attachments && view_details.attachments.length > 0">
                  <div v-for="(attachment, index) in view_details.attachments" :key="index" class="image-container">
                    <img :src="attachment" alt="No Image Found" class="image-view" >
                  </div>
                </td>
                <td v-else>
                  <span class="ItemDetailContent col-6 sm-6">-</span>
                </td>
              </tr>
              <tr>
                <th class="itemDetailHeader col-4 sm-4">Video</th>
                <td class="ItemDetailContent col-6 sm-6">{{ '-' }}</td>
              </tr>
              </tbody>
            </table>
          </v-container>
        </v-card>
      </v-dialog>
      <v-row justify="center">
        <v-dialog v-model="successPopup" persistent max-width="424px">
          <v-card class="v-card-100 pa-2">
            <v-card-title>
              <v-spacer></v-spacer>
            </v-card-title>
            <v-card-text class="text-center">
              <span > {{message}} </span>
            </v-card-text>
            <v-card-actions center>
                <v-spacer></v-spacer>
                <v-btn color="primary" variant="flat" class="mb-3" @click="closePopup">Ok</v-btn>
                <v-spacer></v-spacer>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-row>
      <v-row justify="center">
        <v-dialog v-model="noClaimPopup" persistent max-width="532px">
          <v-card class="v-card-100 pa-2">
            <v-card-title>
              <v-spacer></v-spacer>
            </v-card-title>
            <v-card-text class="text-center">
              <div > Are you sure you want to raise 'No Claim' for selected IRD's ? </div>
              <div class="mt-6" v-if="active_tab == 'For Short Quantity Received'"> <strong>Note: </strong> If recovery is less than MAP, it will sent for approval.</div>
            </v-card-text>
            <v-card-actions class="my-3">
                <v-spacer></v-spacer>
                <v-btn color="primary" variant="outlined" class="mb-3 text-none" @click="noClaimPopup = false">Cancel</v-btn>
                <v-btn color="primary" variant="flat" class="mb-3 text-none" @click="NoClaim" v-if="active_tab != 'Write Off Items'">Confirm</v-btn>
                <v-btn color="primary" variant="flat" class="mb-3 text-none" @click="NoClaimWriteOffItems" v-else>Confirm</v-btn>
                <v-spacer></v-spacer>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-row>
      <v-row justify="center">
        <v-dialog v-model="imagePopup" persistent :max-width="dialogMaxWidth">
          <v-card class="v-card-100">
            <v-card-title class="d-flex align-center pt-0 pr-0">
              <v-spacer></v-spacer>
              <v-btn variant="solo" icon @click="imagePopup = false">
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-card-title>
            <v-card-text>
              <img :src="modalImageUrl" alt="Image" style="max-width: 100%; max-height: 100%;" />
            </v-card-text>
          </v-card>
        </v-dialog>
      </v-row>
       <!-- raise new claim  -->
    <v-row justify="center">
      <v-dialog v-model="RaiseNewClaimPopup" persistent max-width="500px">
        <v-card class="v-card-100">
          <v-card-title class="d-flex align-center">
          <v-row class="pa-2">
            <span style="font-weight:600;">Create New Claim</span>
            <v-spacer></v-spacer>
              <v-icon @click="RaiseNewClaimPopup = false">mdi-close</v-icon>
            </v-row>
          </v-card-title>
          <v-divider :thickness="4" class="m-0" />
          <v-container>
            <v-row class="pa-5">
              <v-col>
                <v-text-field variant="outlined"   
                   append-inner-icon="mdi-magnify" 
                   label="Search Tag ID" 
                   outlined 
                   v-model="seacrh_tag" 
                   v-on:keyup="validateTag"
                   :error="tagInvalid === true"
                   :success="tagInvalid === false"
                   :error-messages="tagInvalid ? tagValidationMessage : ''"
                   :success-messages="!tagInvalid ? 'sdsd' : ''"
                   > </v-text-field>
              </v-col>
            </v-row> 
          </v-container>
          <v-card-actions style="justify-content: center;">
            <v-btn small color="primary" variant="flat" class="mb-3 text-none" :disabled="!seacrh_tag || number>0 || tagInvalid" @click="createNewRequest">Create</v-btn>
            <v-btn small color="normal" variant="outlined"  class="mb-3 text-none" @click="RaiseNewClaimPopup = false">Cancel</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>
    <!-- popups end -->
    <!-- action buttons and search -->
    <v-card-title style="padding: 25px 25px 15px 15px;" class="action-style mt-6 pb-1">
      <v-row class="m-0 d-flex align-center">
        <!-- search type -->
        <v-autocomplete 
           class="mr-4" 
           v-model="field_type" 
           :items="field_item" 
           item-value="id"
           item-title="value"  
           style="max-width: 150px;"            
           label="Select Field" 
           variant="outlined" 
           v-if="active_tab == 'Insurance Claim For Short Items' || active_tab == 'For Short Quantity Received' || active_tab == 'Write Off Items' || active_tab == 'Pending For Approval'">
          </v-autocomplete >
        <v-autocomplete 
           class="mr-4" 
           v-model="tag_number" 
           :items="tag_number_items" 
           item-value="value" 
           style="max-width: 150px;" 
           item-title="id" label="Select Field" 
           variant="outlined" 
           v-if="active_tab == 'Condition Mismatch'">
           </v-autocomplete >
        <v-autocomplete 
          class="mr-4" 
          v-model="Ecom_Pending" 
          :items="Ecom_Pending_items" 
          item-value="value" 
          style="max-width: 150px;" 
          item-title="id" 
          label="Select Field" 
          variant="outlined" 
          v-if="active_tab == 'Against E-com Market Places' || active_tab == 'Pending For Resolution'">
          </v-autocomplete >
        <!--search field  -->
        <v-text-field prepend-inner-icon="mdi-magnify"  v-model="inward_search" v-no-edge-space label="Search" style="max-width: 300px;" variant="outlined" v-on:keyup.enter="loadData(active_tab)"></v-text-field>
        <v-spacer></v-spacer> 
        <!-- action buttons -->
        <v-card-actions style="margin-bottom: 18px;padding-top: 0px; padding-bottom: 0px;" v-if="active_tab == 'Insurance Claim For Short Items' && isActionAllowed(role)" >
          <v-btn class="mr-2  text-none" size="x-large" variant="flat" :disabled="selected.length == 0" color="primary"  @click="ShortItemRaiseClaim">Raise claim</v-btn>
          <v-btn class="mr-2  text-none" size="x-large" variant="flat" :disabled="selected.length == 0" color="primary"  @click="NoClaimPopup">No Claim</v-btn>
        </v-card-actions>
        <v-card-actions style="margin-bottom: 28px;padding-top: 0px; padding-bottom: 0px;" v-if="active_tab == 'For Short Quantity Received' && isActionAllowed(role)">
          <v-btn class="mr-2 text-none" size="x-large" variant="flat" :disabled="selected.length == 0 || this.selected.length > 1" color="primary" @click="shortQuantityReceived(selected)">Raise claim</v-btn>
          <v-btn class="mr-2 text-none" size="x-large" variant="flat" :disabled="selected.length == 0" color="primary" @click="NoClaimPopup">No Claim</v-btn>
        </v-card-actions>
        <v-card-actions style="margin-bottom: 28px;padding-top: 0px; padding-bottom: 0px;" v-if="active_tab == 'Condition Mismatch' && isActionAllowed(role)">
          <v-btn class="mr-2  text-none" size="x-large" variant="flat" :disabled="selected.length == 0 || this.selected.length > 1" color="primary" @click="raiseClaimCM">Raise claim</v-btn>
          <v-btn class="mr-2 text-none" size="x-large" variant="flat" :disabled="selected.length == 0" color="primary" @click="NoClaimPopup">No Claim</v-btn>
          <v-btn class="mr-2 text-none" size="x-large" variant="flat" color="primary" @click="createNewClaimPopup">Create New Claim</v-btn>
        </v-card-actions>
        <v-card-actions style="margin-bottom: 28px;padding-top: 0px; padding-bottom: 0px;" v-if="active_tab == 'Logistic Damage' && isActionAllowed(role)">
          <v-btn class="mr-2 text-none" size="x-large" variant="flat" :disabled="selected.length == 0" color="primary" @click="raiseLogisticClaim">Raise claim</v-btn>
          <v-btn class="mr-2 text-none" size="x-large" variant="flat" :disabled="selected.length == 0" color="primary" @click="NoClaimPopup">No Claim</v-btn>
        </v-card-actions>
        <v-card-actions style="margin-bottom: 28px;padding-top: 0px; padding-bottom: 0px;" v-if="active_tab == 'Against E-com Market Places' && isActionAllowed(role)">
          <v-btn class="mr-2 text-none" size="x-large" variant="flat" :disabled="selected.length == 0" color="primary" @click="EComMarket">Raise claim</v-btn>
          <v-btn class="mr-2 text-none" size="x-large" variant="flat" :disabled="selected.length == 0" color="primary" @click="NoClaimPopup">No Claim</v-btn>
        </v-card-actions>
        <v-card-actions style="margin-bottom: 28px; padding-top: 0px; padding-bottom: 0px;" v-if="active_tab == 'Write Off Items' && isActionAllowed(role)">
          <v-btn class="mr-2 text-none" color="primary" size="x-large" variant="flat" :disabled="(this.selected.length == 0)" @click="shortQuantityReceived('write_off_items')">Raise claim</v-btn>
          <v-btn class="mr-2 text-none" color="primary" size="x-large" variant="flat" :disabled="(this.selected.length == 0)" @click="NoClaimPopup">No Claim</v-btn>
        </v-card-actions>
        <v-card-actions style="margin-bottom: 28px;padding-top: 0px; padding-bottom: 0px;" v-if="active_tab == 'Pending For Resolution' && isActionAllowed(role)">
          <v-btn class="mr-2 text-none" size="x-large" variant="flat" :disabled="selected.length == 0" color="primary" @click="pendingUpdateClaim">Update Claim</v-btn>
        </v-card-actions>
      </v-row>
    </v-card-title>
    <!-- action buttons and search end -->
    <!-- table  -->
    <v-layout column>
      <!-- <v-flex md6 style="overflow: auto"> -->
        <v-data-table hover
          density="compact"
          :search="search"
          v-model="selected"
          show-select
          disable-pagination
          :hide-default-footer="true"
          :headers="computedHeaders"
          :items="table_data"
          :loading="loading"
          :items-per-page="pageSize"
          fixed-header
          height="100%"
          loading-text="Loading Data... Please wait" class="elevation-1"
          return-object
          >
          <template v-slot:[`item.${header.key}`]="{ item }" v-for="header in headers">
             <span v-if="header.key === 'tag_number' && active_tab == 'Condition Mismatch'">                
                  {{ item.tag_number ? item.tag_number : '-' }}<v-icon style="font-size:22px !important;" color="secondary" class="ml-2" @click.prevent="itemDetailPopup(item, 'Tag Details')">mdi-information-outline</v-icon>              
              </span>
              <span v-else-if="header.key === 'ird_number' && active_tab == 'For Short Quantity Received'">                
                  {{ item.ird_number ? item.ird_number : '-' }}<v-icon style="font-size:22px !important;" color="secondary" class="ml-2" @click.prevent="itemDetailPopup(item, 'IRD Details')">mdi-information-outline</v-icon>              
              </span>  
            <span v-else-if="header.key === 'acknowledgement_receipt_url' && active_tab == 'Logistic Damage'">
                <a @click.prevent="openModal(item.acknowledgement_receipt_url)" style="text-decoration: underline; color:#1976d2; cursor: pointer;">
                  View
                </a>
              </span>
              <span v-else-if="header.key == 'short_quantity_value'">
                <span>{{ item.short_quantity_value ? item.short_quantity_value.toLocaleString('en-IN') : '-' }}</span>
              </span> 
              <span v-else-if="header.key == 'total_ird_value'">
                <span>{{ item.total_ird_value ? item.total_ird_value.toLocaleString('en-IN') : '-' }}</span>
              </span> 
              <span v-else-if="header.key == 'claim_amount'">
                <span>{{ item.claim_amount ? item.claim_amount.toLocaleString('en-IN') : '-' }}</span>
              </span>
               <span v-else-if="header.key == 'write_off_date'">
                <span>{{ formatReverseDate(item.write_off_date) }}</span>
              </span>  
              <span v-else-if="header.key !== 'mismatch_details' && item[header.key]">
                <span v-tooltip="item[header.key]">
                  {{ item[header.key].length > 20 ? item[header.key].slice(0, 20) + '...' : item[header.key] }}
                </span>
              </span>
              <span v-else-if="header.key === 'mismatch_details' && active_tab == 'Condition Mismatch'">
                <a @click.prevent="itemDetailPopup(item, 'Mismatch Details')" style="text-decoration: underline; color:#1976d2; cursor: pointer;">
                  View Details  
                </a>
              </span>
              <span v-else-if="header.key === 'tag_number' && active_tab == 'Condition Mismatch'">
                <a @click.prevent="itemDetails(item)" style="text-decoration: underline; color:#1976d2; cursor: pointer;">
                  {{ item.tag_number ? item.tag_number : '-' }}
                </a>
              </span>
              <span v-else-if="header.key === 'acknowledgement_receipt_url' && active_tab == 'Logistic Damage'">
                <a @click.prevent="openModal(item.acknowledgement_receipt_url)" style="text-decoration: underline; color:#1976d2; cursor: pointer;">
                  View
                </a>
              </span>
              <span v-else-if="header.key === 'item_description' && active_tab == 'Pending For Resolution' || active_tab == 'Against E-com Market Places'">
                <a @click.prevent="itemDetails(item)" style="text-decoration: underline; color:#1976d2; cursor: pointer;">
                  View
                </a>
              </span>                           
              <span v-else>-</span>
          </template>
            <template #bottom></template>
          </v-data-table> 
    </v-layout>
    <!-- table end -->
    <!-- pagination -->
    <PaginationComponent
                    :pageSize="pageSize"
                    :pageSizes="pageSizes"
                    :totalCount="totalCount"
                    :selected="selected"
                    :page="page"
                    :totalPages="totalPages"
                    @update:pageSize="handlePageSizeChange"
                    @update:page="handlePageChange"
                    class="mt-2 mb-0"
                />
    <!-- pagination end -->
  </v-card>
</template>
<script>
  import HeaderComponent from "../../../commoncomponents/HeaderComponent.vue";
  import { defaultPageSize, defaultPageSizes } from '@/components/commoncomponents/PaginationComponent.vue';
  import { isOnlyViewAction } from '@/backend/axios/moduleAccess'
  export default {
    data() {
      return {
        headerText: "Claim Raise Bucket",
        tabs2: [
          "Pending For Resolution",
          "Pending For Approval"
        ],
        active_tab: "Insurance Claim For Short Items",
        alert: false,
        alert_type: 'info',
        alert_message: '',
        headers: [
          { title: "Tag ID", key: "tag_number", width: '12%', align: "start", sortable: false },
          { title: "Category", key: "category" },
        ],
        inward_search:'',
        field_type:null,
        field_item:[
          {
            id : "ird_number",
            value: "IRD Number"
          }
        ],
        selected:[],
        search:'',
        table_data:[],
        totalCount: '',
        loading: false,
        page: 1,
        totalPages: [],
        selected_tab: 0,
        pageSize: defaultPageSize,
        pageSizes: defaultPageSizes,
        createLotDropDown: false,
        createLotSubTab : [
          "Insurance Claim For Short Items",
          "For Short Quantity Received",
          "Condition Mismatch",
          "Write Off Items",
          "Logistic Damage",
          "Against E-com Market Places"          
        ],
        selectedCreateLotSubtab : "For Short Quantity Received",
        RaiseClaimPopup: false,
        viewDetailsPopup: false,
        view_details:[],
        condition_mismatch_items : [],
        viewDetailsHeader:[
          { title: "Tag ID", key: "tag_number", width: '12%', align: "start", sortable: false },
          { title: "Category", key: "category" },
        ],
        shortQtyHeader:[
          // { text: "ID", value: "id"},
          { title: "Article ID", value: "sku_code", align: "start", sortable: false },
          { title: "Article Description", value: "sku_description" },
          { title: "MAP", value: "map" },
          { title: "", value: "claim_amount", width:"250px"},
          { title: "", value: "update_vendor_code", width:"250px"},
          { title: "", value: "claim_tracking_number", width:"250px"},
        ],
        updateAmount:'',
        logisticRaiseClaimPopup: false,
        updateClaimPopup: false,
        resolutionItemDetailPopup: false,
        item_id: '',
        id:'',
        successPopup : false,
        message : '',
        noClaimPopup : false,
        imagePopup : false,
        logistic_damage : [],
        viewDetailsSubHeader: [
            { title: "Claim Amount", key: "claim_amount",minWidth:"150px"},
            { title: "Vendor", key: "vendor",minWidth:"150px"},
            { title: "Claim Reference Number", key: "claim_reference_number",minWidth:"200px"}
        ],
        logistic_damage_items : [
          {
            id : "ddn",
            value: "DDN"
          }
        ],
        tag_number : '',
        tag_number_items : [
          {
            id : "Tag Number",
            value: "tag_number"
          },
          {
            id : "IRD NO",
            value: "ird_number"
          }
        ],
        Ecom_Pending : '',
        Ecom_Pending_items : [
          {
            id : "Consignee Ref Doc No",
            value: "crd_number"
          },
          {
            id : "Vendor Ref No",
            value: "vrd_number"
          },
          {
            id : "Tag ID",
            value: "tag_number"
          }
        ],
        imagePopup : false,
        modalImageUrl: '',
        creditNoteAmount : '',
        ApprovalNumber : '',
        Remarks : '',
        claimNumber : '',
        approveReject : '',
        conditionMismatchPopup : false,
        mismatchAmount : '',
        number:0,
        ShortItemRaiseClaimPopup: false,
        shortQuantityReceivedPopup: false,
        short_qty_amount: '',
        update_vendor_code: '',
        short_qty_items: [],
        formattedVendorCode: '',
        formattedLogisticVendorCode: '',
        role:'',
        organization_name:'',
        update_vendor_items : '',
        seacrh_tag:'',
        RaiseNewClaimPopup:false,
        tagInvalid: false,
        tagValidationMessage: '',
        tagValidationMessage1:'',
      }
    },
    components: {
      HeaderComponent
    },
    created() {
      const tab = this.$store.state.active_tab
      this.role = this.$store.state.currentUser.roles[0]
      if(tab == 'Pending For Resolution'){
        this.loadData('Pending For Resolution')
        this.selected_tab = 1
      } else {
        this.selected_tab = 0
        if(this.createLotSubTab.includes(tab))
          this.loadData(tab)
        else this.loadData('Insurance Claim For Short Items')
      }
      this.getVendorList();
    },
    computed: {
      dialogMaxWidth() {
        if (this.$refs.popupImage) {
          const imageWidth = this.$refs.popupImage.clientWidth;
          return `${imageWidth + 32}px`;
        }
        return '600px';
      },
      isRejectSelected() {
        return this.approveReject === 'Reject';
      },
      formattedUpdateAmount : {
        get() {
          return (this.updateAmount).toLocaleString('en-IN') ;
        },
        set(value) {
          const numericValue = Number(value.replace(/[^0-9.-]+/g, ''));
          this.updateAmount = Math.max(parseFloat(numericValue), '');
        }
      },
      formattedMismatchAmount : {
        get() {
          return (this.mismatchAmount).toLocaleString('en-IN') ;
        },
        set(value) {
          const numericValue = Number(value.replace(/[^0-9.-]+/g, ''));
          this.mismatchAmount = Math.max(parseFloat(numericValue), '');
        }
      },
      computedHeaders() {
        if (this.$isRelianceClient() || this.active_tab === 'Insurance Claim For Short Items') {
          return this.headers.filter(header => header.value !== 'supplier_organization' || header.value !== 'supplier_organization');          
        } else if(this.$isRelianceClient() || this.active_tab === 'For Short Quantity Received') {
          return this.headers.filter(header => header.value !== 'supplier_organization' && header.value !== 'supplier_organization');          
        }else{
          return this.headers;
        }
      },
      isFormValid() {
        // return this.short_qty_items.every(item => 
        //   item.claim_amount && item.update_vendor_code
        // );
        if(this.active_tab === "Insurance Claim For Short Items"){
          return this.short_qty_items.some(item => item.claim_amount && item.update_vendor_code && item.claim_tracking_number);
        }else{
          return this.short_qty_items.some(item => item.claim_amount && item.update_vendor_code && item.claim_tracking_number);
        }
        
      },
    },
    methods: {
      isActionAllowed(){
        return !isOnlyViewAction(this.role, 'Inwarding')
      },
      isDisabledSubtab(subtab) {
        return subtab === 'Logistic Damage' || subtab === 'Against E-com Market Places';
      },
      loadData(tab, tab_action) {
        this.$store.commit('setActiveTab',{
          'active_tab' : tab
        })
        if(tab == "Insurance Claim For Short Items") { this.selectedCreateLotSubtab = tab; }
        else if(tab == 'Insurance Claim For Short Items'){ this.selectedCreateLotSubtab = "Insurance Claim For Short Items"; tab = this.selectedCreateLotSubtab;}
          else if(tab == 'For Short Quantity Received'){ this.selectedCreateLotSubtab = "For Short Quantity Received"; tab = this.selectedCreateLotSubtab;}
          else if(tab == 'Condition Mismatch') { this.selectedCreateLotSubtab = "Condition Mismatch"; tab = this.selectedCreateLotSubtab;} 
          else if(tab == 'Logistic Damage'){ this.selectedCreateLotSubtab = "Logistic Damage"; tab = this.selectedCreateLotSubtab;}
          else if(tab == 'Against E-com Market Places'){ this.selectedCreateLotSubtab = "Against E-com Market Places"; tab = this.selectedCreateLotSubtab;}
          else if(tab == 'Write Off Items'){ this.selectedCreateLotSubtab = "Write Off Items"; tab = this.selectedCreateLotSubtab;}
          else { this.selectedCreateLotSubtab = "Insurance Claim For Short Items";}

        if(tab_action){
          this.inward_search = null;
          this.field_type = null;
          this.logistic_damage = '';
          this.tag_number = '';
          this.Ecom_Pending = '';
        }
        this.active_tab = tab
        this.table_data = []
        this.page = 1
        this.totalPages = 1
        this.selected = []

        if (tab == "Insurance Claim For Short Items") {
          this.headers = [
            { title: "IRD No.", key: "ird_number", align: "start", sortable: false, width: "12%" },
            { title: "Receiving Location", key: "receiving_site", sortable: true, minWidth:"200px" },
            { title: "Sender", key: "supplier_organization",},
            { title: "Qty as per IRD", key: "ird_quantity",minWidth:"250px"  },
            { title: "Value as per IRD (₹)", key: "total_ird_value",minWidth:"250px"  },
            { title: "Qty as per GRN", key: "inwarded_quantity", minWidth:"200px"  },
            { title: "Short Qty", key: "short_quantity", minWidth:"200px" },
            { title: "Short Qty (₹)", key: "short_quantity_value", minWidth:"140px"  },
          ];
          this.InsuranceClaimShortITems();
        }
        if (tab == "For Short Quantity Received") {
          this.headers = [
            { title: "IRD No.", key: "ird_number", align: "start", sortable: false, width: "12%" },
            { title: "Receiving Location", key: "receiving_site", sortable: true, minWidth:"200px" },
            { title: "Sender", key: "supplier_organization", },
            { title: "Qty as per IRD", key: "ird_quantity", minWidth:"350px" },
            { title: "Value as per IRD (₹)", key: "total_ird_value",minWidth:"350px" },
            { title: "Qty as per GRN", key: "inwarded_quantity", minWidth:"200px" },
            { title: "Short Qty", key: "short_quantity", minWidth: "140px"  },
            { title: "Short Qty (₹)", key: "short_quantity_value",minWidth:"140px"  },
          ];
          this.getShortQuantityReceived();
        } if (tab == 'Pending For Resolution') {
            this.headers = [
              { title: "Vendor", key: "vendor_name", align: "start", sortable: false,},
              { title: "Channel", key: "channel", sortable: true },
              { title: "Consignee Reference document number", key: "consignee_reference_document_number",minWidth:"350px" },
              { title: "Vendor reference number", key: "vendor_reference_document_number",minWidth:"250px" },
              { title: "Tag ID", key: "tag_number",minWidth:"120px" },
              { title: "Article ID", key: "sku_code",minWidth:"140px" },
              { title: "Serial Number", key: "serial_number", minWidth:"200px" },
              { title: "Item Details", key: "item_description",minWidth:"200px" },
              { title: "Claim Number", key: "claim_number",minWidth:"200px" },
              { title: "Claim Amount (₹)", key: "claim_amount",minWidth:"200px" },              
              { title: "Status", key: "claim_status", },

            ];
            this.pendingForResolution();
        } if (tab == 'Condition Mismatch') {
            this.headers = [
              { title: "IRD N0.", key: "ird_number", sortable: false },
              { title: "Tag ID", key: "tag_number", },
              { title: "Article ID", key: "sku_code",minWidth:"140px" },
              { title: "Article Description", key: "sku_description", align: "start",minWidth:"200px"},
              { title: "Serial Number", key: "serial_number1",minWidth:"200px" },
              { title: "Previous Grading Partner", key: "prev_grading_partner", sortable: true,minWidth:"250px" },
              { title: "Previous Grade", key: "prev_grade",minWidth:"200px" },
              { title: "Inward Grade", key: "grade",minWidth:"170px" },
              { title: "Mismatch Details", key: "mismatch_details",minWidth:"200px" },
            ];
            this.conditionMismatch();
        } if (tab == 'Logistic Damage') {
            this.headers = [
              { title: "DDN", key: "dispatch_document_number", align: "start", sortable: false, width: "12%" },
              { title: "Logistic Vendor", key: "logistics_partner", sortable: true, minWidth:"140px" },
              { title: "Acknowledge Receipt", key: "acknowledgement_receipt_url", minWidth:"200px"},
              { title: "Short Quantity", key: "short_quantity",minWidth:"140px" },
              { title: "Short Value (₹)", key: "short_quantity_value",minWidth:"140px" },
            ];
            this.logisticMismatch();
        } if (tab == 'Against E-com Market Places') {
            this.headers = [
              { title: "Vendor", key: "vendor_name", align: "start", sortable: false, width: "12%" },
              { title: "Channel", key: "channel", sortable: true },
              { title: "Consignee Reference document number", key: "consignee_reference_document_number", minWidth:"350px" },
              { title: "Vendor reference number", key: "vendor_reference_document_number",minWidth:"250px" },
              { title: "Tag ID", key: "tag_number",minWidth:"140px" },
              { title: "Article ID", key: "sku_code",minWidth:"140px" },
              { title: "Serial Number", key: "serial_number",minWidth:"200px" },
              { title: "Item Details", key: "item_description",minWidth:"140px" },
              { title: "Status", key: "claim_status", },
            ];
            this.EcomMarketPlace();
        }
        if(tab == 'Write Off Items'){
          this.headers = [
              { title: "Tag ID", key: "tag_number", sortable: false },
              { title: "IRD No.", key: "ird_number", sortable: false },
              { title: "Article ID", key: "article_id", sortable: false },
              { title: "Article Description", key: "article_description", sortable: false },
              { title: "Serial Number 1", key: "serial_number_1", sortable: false },
              { title: "Serial Number 2", key: "serial_number_2", sortable: false },
              { title: "Date", key: "write_off_date", sortable: false },
              { title: "Map (₹)", key: "map", sortable: false },              
              { title: "Module", key: "disposition_from", sortable: false },
            ];
            this.field_item = [
              {
              id : "tag_number",
              value: "Tag Number"
              },
              {
                id : "ird_number",
                value: "IRD Number"
              },
              {
                id : "article_id",
                value: "Article ID"
              }
        ],
            this.getWriteOffItems();
        }
        if (tab == 'Pending For Approval') {
              this.headers = [
                      { title: "Location", key: "location"},
                      { title: "IRD", key: "ird" },
                      { title: "Tag ID", key: "tag_number" },
                      { title: "Article ID", key: "article_id" },
                      { title: "Article Description", key: "article_description"},
                      { title: "Lot ID", key: "lot_id" },
                      { title: "Publish ID", key: "publish_id"},
                      { title: "Recovery Benchmark Price", key: "recovery_benchmark_price" },
                      { title: "Serial No.1", key: "serial_number" },
                      { title: "Serial No.2", key: "serial_number2"},
                      { title: "Approval Type", key: "approval_rule_type"},
                      { title: "Pending At", key: "next_approver_details"}
                  ];
             this.field_item = [
                 {
                    "value":"Tag ID",
                    "id": "tag_number"
                  },
                  {
                    "value":"IRD",
                    "id": "ird_number"
                  },
                  {
                    "value":"Lot ID",
                    "id": "lot_id"
                  },
                  {
                    "value":"Publish ID",
                    "id": "publish_id"
                  },
                  {
                    "value":"Pending at",
                    "id": "pending_at"
                  }
            ]
            this.fetchPendingForApproval();
        }
      },
      // get tabs data functions
      InsuranceClaimShortITems(){
        this.loading = true;
        const params = {
          claim_type : 'insurance_claim',
          search: this.inward_search,
          search_in : this.field_type,
          page: this.page,
          per_page: this.pageSize
        };
        this.$httpSecured
          .get('/api/v1/warehouse/short_item_claims', {params : params})
          .then(response => {
              if (response.data) {
                this.table_data = response.data.short_item_claims
                this.totalPages = response.data.meta.total_pages
                this.totalCount = response.data.meta.total_count
                this.loading = false;
              } else {
                this.showAlert("error", "No Data Found");
                this.loading = false;
              }
          })
          .catch(error => {
              this.showAlert("error", "Something went wrong from Network" + error);
              this.loading = false;
          });
      },
      getShortQuantityReceived(){
        this.loading = true;
        const params = {
          search: this.inward_search,
          search_in : this.field_type,
          page: this.page,
          per_page: this.pageSize
        };
        this.$httpSecured
          .get('/api/v1/warehouse/short_item_claims', {params : params})
          .then(response => {
              if (response.data) {
                this.table_data = response.data.short_item_claims
                this.totalPages = response.data.meta.total_pages
                this.totalCount = response.data.meta.total_count
                this.loading = false;
              } else {
                this.showAlert("error", "No Data Found");
                this.loading = false;
              }
          })
          .catch(error => {
              this.showAlert("error", "Something went wrong from Network" + error);
              this.loading = false;
          });
      },
      claimAmountRule(item) {
        return value => {
          if (item.claim_amount_raw === null || item.claim_amount_raw === undefined) {
            return 'Claim amount is required';
          } else if (item.claim_amount_raw > item.map) {
            return `Claim amount cannot be more than ${item.map}`;
          }
          return true;
        };
      },
      pendingForResolution(){
        this.loading = true;
        const params = {
          search: this.inward_search,
          search_in : this.Ecom_Pending,
          page: this.page,
          per_page: this.pageSize
        };
        this.$httpSecured
          .get('/api/v1/warehouse/pending_for_resolution', {params : params})
          .then(response => {
              if (response.data) {
                this.table_data = response.data.inventories
                this.totalPages = response.data.meta.total_pages
                this.totalCount = response.data.meta.total_count
                this.loading = false;
              } else {
                this.showAlert("error", "No Data Found");
                this.loading = false;
              }
          })
          .catch(error => {
              this.showAlert("error", "Something went wrong from Network" + error);
              this.loading = false;
          });
      },
      conditionMismatch(){
        this.loading = true;
        const params = {
          search: this.inward_search,
          search_in : this.tag_number,
          page: this.page,
          per_page: this.pageSize
        };
        this.$httpSecured
          .get('/api/v1/warehouse/condition_mismatch', {params : params})
          .then(response => {
              if (response.data) {
                this.table_data = response.data.pending_receipt_document_items
                this.totalPages = response.data.meta.total_pages
                this.totalCount = response.data.meta.total_count
                this.loading = false;
              } else {
                this.showAlert("error", "No Data Found");
                this.loading = false;
              }
          })
          .catch(error => {
              this.showAlert("error", "Something went wrong from Network" + error);
              this.loading = false;
          });
      },
      logisticMismatch(){
        this.loading = true;
        const params = {
          search: this.inward_search,
          search_in : this.logistic_damage,
          page: this.page,
          per_page: this.pageSize
        };
        this.$httpSecured
          .get('/api/v1/warehouse/logistic_claims', {params : params})
          .then(response => {
              if (response.data) {
                this.table_data = response.data.logistic_claims
                this.totalPages = response.data.meta.total_pages
                this.totalCount = response.data.meta.total_count
                this.loading = false;
              } else {
                this.showAlert("error", "No Data Found");
                this.loading = false;
              }
          })
          .catch(error => {
              this.showAlert("error", "Something went wrong from Network" + error);
              this.loading = false;
          });
      },
      EcomMarketPlace(){
        this.loading = true;
        const params = {
          claim_status : 'pending_submission',
          search: this.inward_search,
          search_in : this.Ecom_Pending,
          page: this.page,
          per_page: this.pageSize
        };
        this.$httpSecured
          .get('/api/v1/warehouse/pending_for_resolution', {params : params})
          .then(response => {
              if (response.data) {
                this.table_data = response.data.inventories
                this.totalPages = response.data.meta.total_pages
                this.totalCount = response.data.meta.total_count
                this.loading = false;
              } else {
                this.showAlert("error", "No Data Found");
                this.loading = false;
              }
          })
          .catch(error => {
              this.showAlert("error", "Something went wrong from Network" + error);
              this.loading = false;
          });
      },
      getWriteOffItems(){
        this.loading = true;
        const params = {
          [this.field_type]: this.inward_search,
          page: this.page,
          per_page: this.pageSize
        };
        this.$httpSecured
        .get('/api/v1/warehouse/write_off_items', {params : params})
          .then(response => {
              if (response.data) {
                this.table_data = response.data.write_off_items
                this.totalPages = response.data.meta.total_pages
                this.totalCount = response.data.meta.total_count
                this.loading = false;
              } else {
                this.showAlert("error", "No Data Found");
                this.loading = false;
              }
          })
          .catch(error => {
              this.showAlert("error", "Something went wrong from Network" + error);
              this.loading = false;
          });
      },
      fetchPendingForApproval() {
        this.loading = true;
        const params = {
          [this.field_type]: this.inward_search,
          page: this.page,
          per_page: this.pageSize
        };
        this.$httpSecured
        .get('/api/v1/warehouse/short_item_claims/pending_approvals', {params : params})
          .then(response => {
              if (response.data) {
                this.table_data = response.data.approval_requests
                this.totalPages = response.data.meta.total_pages
                this.totalCount = response.data.meta.total_count
                this.loading = false;
              } else {
                this.showAlert("error", "No Data Found");
                this.loading = false;
              }
          })
          .catch(error => {
              this.showAlert("error", "Something went wrong from Network" + error);
              this.loading = false;
          });
      },
      ShortItemRaiseClaim(){
        this.ShortItemRaiseClaimPopup = true
      },
      formatClaimAmount(event, item) {
        let inputValue = event.target.value.replace(/[^\d.]/g, '');
        item.claim_amount_raw = Number(inputValue);
        item.claim_amount = inputValue && inputValue > 0  ? item.claim_amount_raw.toLocaleString('en-IN') : '';
      },
      shortQuantityReceived(item){
        if(item === 'write_off_items'){
          this.shortQtyHeader = [
              { title: "Article ID", key: "article_id", align: "start", sortable: false },
              { title: "Article Description", key: "article_description" },
              { title: "", key: "claim_amount", width:"250px" },
              { title: "", key: "update_vendor_code", width:"250px" },
              { title: "", value: "claim_tracking_number", width:"250px"},
          ]
          this.shortQuantityReceivedPopup = true
          this.short_qty_items = this.selected.map(item => ({
            ...item,
            claim_amount: '', 
            update_vendor_code: null,
            claim_tracking_number: '',
          }));

        }else{
         const params = {
          id: item[0].id
        }
        this.shortQuantityReceivedPopup = true;
        this.shortQtyHeader = [
              { title: "Article ID", value: "sku_code", align: "start", sortable: false },
              { title: "Article Description", value: "sku_description" },
              { title: "MAP", value: "map" },
              { title: "", value: "claim_amount", width:"250px"},
              { title: "", value: "update_vendor_code", width:"250px"},
              { title: "", value: "claim_tracking_number", width:"250px"},
          ]
        this.$httpSecured
        .get('/api/v1/warehouse/short_item_claims/short_details', {params: params})
        .then((response) => {
          if (response.data) {
            this.short_qty_items = response.data.short_items
            this.loading = false;
          } else {
            this.loading = false;
            this.showAlert("error", "No Data Found");
          }
        })
        .catch(error => {
          this.showAlert("error", "Something went wrong from Network" + error);
          this.loading = false;
        });
      }
      },
      // get table data ends
      RaiseClaim(){
        this.loading = true;
        const shortItems = this.selected.map(item => item.id)
        let requestBody = {};
        if (this.active_tab === "Insurance Claim For Short Items"){
          var apiUrl = '/api/v1/warehouse/short_item_claims/raise_insurance_claim'
          requestBody = {
            ids : shortItems
          };
        }
        if (this.active_tab === "For Short Quantity Received"){
          var apiUrl = '/api/v1/warehouse/short_item_claims/raise_claim'
          const shortItemsData = this.short_qty_items
          .map(item => {
            const claimAmount = item.claim_amount || null;
            const vendorCode = item.update_vendor_code || null;

            // Include only if at least one field is non-null
            if (claimAmount !== null || vendorCode !== null) {
              return {
                id: item.id,
                claim_amount: claimAmount,
                vendor_code: vendorCode,
                claim_tracking_number: item.claim_tracking_number
              };
            }
            return null;
          })
          .filter(Boolean);
          
          requestBody = {
            id: shortItems,
            short_items: shortItemsData
          };
        }
        if (this.active_tab === "Logistic Damage"){
          var apiUrl = `/api/v1/warehouse/logistic_claims/${shortItems}/raise_claim`
        }
        if (this.active_tab === "Against E-com Market Places"){
          var apiUrl = `/api/v1/warehouse/pending_for_resolution/${shortItems}/raise_claim`
        }
        if (this.active_tab === "Write Off Items"){
          var apiUrl = '/api/v1/warehouse/write_off_items/raise_claims'
          const raiseClaims = this.short_qty_items.reduce((acc, item) => {
            const cleanClaimAmount = String(item.claim_amount).replace(/,/g, '');
              acc[item.id] = `${cleanClaimAmount}:${item.update_vendor_code}:${item.claim_tracking_number}`;
              return acc;
            }, {});
          requestBody = {
            raise_claims: raiseClaims
          };
        }
        this.$httpSecured
        .post(apiUrl, requestBody)
          .then(response => {
            if (response.data) {
              this.successPopup = true
              this.message = response.data.message
              this.ShortItemRaiseClaimPopup = false,
              this.shortQuantityReceivedPopup = false,
              this.loading = false;
            } else {
              this.showAlert("error", "No Data Found");
              this.loading = false;
            }
          })
          .catch(error => {
            this.showAlert("error", error.response.data.error);
            this.loading = false;
          });
      },
      NoClaimPopup(){
        this.noClaimPopup = true
      },
      NoClaim(){
        const shortItems = this.selected.map(item => item.id)
        const requestBody = {
          ids : shortItems
        };
        if (this.active_tab === "Insurance Claim For Short Items" || this.active_tab === "For Short Quantity Received"){
          var apiUrl = '/api/v1/warehouse/short_item_claims/no_claim'
        } else if (this.active_tab === 'Logistic Damage') {
          var apiUrl = '/api/v1/warehouse/logistic_claims/no_claim'
        } else if (this.active_tab === 'Against E-com Market Places') {
          var apiUrl = '/api/v1/warehouse/pending_for_resolution/no_claim'
        } else if (this.active_tab === 'Condition Mismatch') {
          var apiUrl = '/api/v1/warehouse/condition_mismatch/no_claim'
        } 
        this.$httpSecured
        .post(apiUrl, requestBody)
          .then(response => {
            this.noClaimPopup = false
            if (response.data) {
              this.successPopup = true
              this.message = response.data.message
              this.loading = false;
            } else {
              this.showAlert("error", "No Data Found");
              this.loading = false;
            }
          })
          .catch(error => {
            this.noClaimPopup = false
            this.showAlert("error", error.response.data.error);
            this.loading = false;
          });
      },
      NoClaimWriteOffItems(){
        const shortItems = this.selected.map(item => item.id)
        const requestBody = {
          ids : shortItems.join(',')
        };
        this.$httpSecured
        .post("/api/v1/warehouse/write_off_items/no_claims", requestBody)
          .then(response => {
            this.noClaimPopup = false
            if (response.data) {
              this.successPopup = true
              this.message = response.data.message
              this.loading = false;
            } else {
              this.showAlert("error", "No Data Found");
              this.loading = false;
            }
          })
          .catch(error => {
            this.noClaimPopup = false
            this.showAlert("error", error.response.data.error);
            this.loading = false;
          });
      },
      SubmitRaiseClaim (){
        this.number++;
        const shortItems = this.selected.map(item => item.id)
        const requestBody = {
          claim_amount : this.updateAmount
        };
        this.$httpSecured
        .put(`api/v1/warehouse/logistic_claims/${shortItems}/raise_claim`, requestBody)
          .then(response => {
            if (response.data) {
              this.successPopup = true
              this.message = response.data.message
              this.loading = false;
              this.updateAmount = '';
            } else {
              this.showAlert("error", "No Data Found");
              this.loading = false;
            }
          })
          .catch(error => {
            this.showAlert("error", error.response.data.error);
            this.loading = false;
          });
      },
      closePopup(){
        this.successPopup = false
        this.loadData(this.active_tab);
        this.selected = []
        this.logisticRaiseClaimPopup = false
        this.RaiseClaimPopup = false
        this.updateClaimPopup = false
        this.conditionMismatchPopup = false
      },
      // short quantity 
      shortQuantity(){
        const shortItems = this.selected.map(item => item.id)

        this.$httpSecured
          .post('api', requestBody)
          .then(response => {
              if (response.data) {
                this.table_data = response.data
                this.totalPages = response.data.meta.total_pages
                this.totalCount = response.data.meta.total_count
                this.loading = false;
              } else {
                this.showAlert("error", "No Data Found");
                this.loading = false;
              }
          })
          .catch(error => {
              this.showAlert("error", "Something went wrong from Network" + error);
              this.loading = false;
          });
      },
      // popup open function
      EComMarket(){
        this.RaiseClaimPopup = true
        this.number=0;
        this.updateAmount = ''
        this.claimNumber = ''
      },
      raiseClaimCM(){
        this.shortQtyHeader = [
              { title: "Article ID", key: "sku_code", align: "start", sortable: false, width:"150px" },
              { title: "Article Description", key: "sku_description" },
              { title: "", key: "claim_amount", width:"250px" },
              { title: "", key: "update_vendor_code", width:"250px" },
              { title: "", value: "claim_tracking_number", width:"250px"},
          ]
          this.conditionMismatchPopup = true
          this.short_qty_items = this.selected.map(item => ({
          ...item,
          claim_amount: '', 
          update_vendor_code: null,
          claim_tracking_number: '',
        }));
       
        this.number=0;
        this.mismatchAmount = ''
      },
      raiseLogisticClaim(){
        this.logisticRaiseClaimPopup = true;
        this.number=0;
        this.updateAmount = ''
      },
      pendingUpdateClaim(){
        this.updateClaimPopup = true
        this.number = 0;
        this.creditNoteAmount = ''
        this.ApprovalNumber = ''
        this.Remarks = ''
      },
      openRemark(){
        this.itemViewDetailsPopup = true;
      },
      ecomMarSubmit(){
        this.number++;
        const shortItems = this.selected.map(item => item.id)
        const requestBody = {
          claim_amount : this.updateAmount,
          claim_number : this.claimNumber
        };
        this.$httpSecured
        .put(`/api/v1/warehouse/pending_for_resolution/${shortItems}/raise_claim`, requestBody)
          .then(response => {
            if (response.data) {
              this.successPopup = true
              this.message = response.data.message
              this.loading = false;
              this.updateAmount = '';
              this.claimNumber = '';
            } else {
              this.showAlert("error", "No Data Found");
              this.loading = false;
            }
          })
          .catch(error => {
            this.showAlert("error", error.response.data.error);
            this.loading = false;
          });
      },
      SubmitUpdateClaim(){
        this.number++
        const shortItems = this.selected.map(item => item.id)
        const requestBody = {
          claim_type : this.approveReject,
          approval_number : this.ApprovalNumber,
          approved_amount : this.creditNoteAmount,
          remarks : this.Remarks
        };
        this.$httpSecured
        .put(`/api/v1/warehouse/pending_for_resolution/${shortItems}/update_claim`, requestBody)
          .then(response => {
            if (response.data) {
              this.successPopup = true
              this.message = response.data.message
              this.loading = false;
              this.updateAmount = '';
            } else {
              this.showAlert("error", "No Data Found");
              this.loading = false;
            }
          })
          .catch(error => {
            this.showAlert("error", error.response.data.error);
            this.loading = false;
          });
      },
      mismatchSubmit(){
        this.number++;
        const shortItems = this.selected.map(item => item.id)
        // const requestBody = {
        //   claim_amount : this.mismatchAmount,
        //   vendor_code: this.formattedVendorCode
        // };
        const shortItemData = {
              claim_amount: parseFloat(this.short_qty_items[0].claim_amount.replace(/,/g, '')), 
              vendor_code: this.short_qty_items[0].update_vendor_code,
              claim_tracking_number: this.short_qty_items[0].claim_tracking_number 
            };
        this.$httpSecured
        .put(`/api/v1/warehouse/condition_mismatch/${shortItems}/raise_claim`,shortItemData )
          .then(response => {
            if (response.data) {
              this.successPopup = true
              this.message = response.data.message
              this.loading = false;
              this.updateAmount = '';
              this.claim_number = '';
              this.number = 0;
            } else {
              this.showAlert("error", "No Data Found");
              this.loading = false;
              this.number = 0;
            }
          })
          .catch(error => {
            this.showAlert("error", error.response.data.error);
            this.loading = false;
            this.number = 0;
          });
      },
      itemDetailPopup(item, condition) {
        this.condition_mismatch_items = [];
        if(condition == 'Tag Details'){
          this.tagIdDetails(item, condition)
          this.viewDetailsPopup = true;
          this.id = `Tag ID: ${item.tag_number}`;
          this.viewDetailsHeader = [
            { title: "IRD", key: "ird_number",minWidth:"120px"},
            { title: "Tag ID", key: "tag_number",minWidth:"150px"},
            { title: "Article ID", key: "article_id",minWidth:"150px"},
            { title: "Article Description", key: "article_description",minWidth:"200px"},
            { title: "Serial Number", key: "serial_number",minWidth:"150px"},
            { title: "Claim Amount", key: "claim_amount",minWidth:"150px"},
            { title: "Vendor", key: "vendor",minWidth:"150px"},
            { title: "Claim Reference Number", key: "claim_reference_number",minWidth:"200px"}
          ]
        }else if(condition == 'IRD Details'){
          this.tagIdDetails(item, condition)
          this.viewDetailsPopup = true;
          this.id = `IRD: ${item.ird_number}`;
          this.viewDetailsHeader = [
            { title: "IRD", key: "ird_number",minWidth:"200px"},
            { title: "Tag ID", key: "tag_number",minWidth:"150px"},
            { title: "Article ID", key: "article_id",minWidth:"150px"},
            { title: "Article Description", key: "article_description",minWidth:"200px"},
            { title: "Serial Number", key: "serial_number",minWidth:"150px"},
          ]
        }else{          
          this.id = `Tag ID: ${item.tag_number}`;
          this.viewDetailsPopup = true
          this.viewDetailsHeader = [
            { title: "Grading Questions", key: "test",sortable: false},
            { title: "Previous Grading Output", key: "value",sortable: false},
            { title: "Inwarding Grading Output", key: "value",sortable: false},
          ];
          this.condition_mismatch_items = item.mismatch_details;
        }
      },
      tagIdDetails(item, condition){
        const itemId = condition == 'Tag Details' ? item.tag_number : item.ird_number;
        const end_point = condition == 'Tag Details' ? `/api/v1/warehouse/condition_mismatch/claim_details?tag_number=${itemId}` : `api/v1/warehouse/short_item_claims/claim_details?ird_number=${itemId}`
        this.$httpSecured
        .get(end_point)
        .then(response => {
          if (response.data) {
            if(condition == 'Tag Details'){
              if(response.data.inventory.claim_details.length > 0){                
                const mainData = response.data.inventory
                const mergedClaimDetails = mainData.claim_details.map(claim => ({
                   ird_number:mainData.ird_number,
                   tag_number:mainData.tag_number,
                   article_id:mainData.article_id,
                   article_description:mainData.article_description,
                   serial_number:mainData.serial_number,
                   claim_amount:claim.claim_amount,
                   vendor:claim.vendor,
                   claim_reference_number:claim.claim_reference_number
              }))
              this.condition_mismatch_items = mergedClaimDetails
              }else{
                this.showAlert("error", "No Data Found");
              }
            }else if(condition == 'IRD Details'){
              this.condition_mismatch_items = response.data.pending_receipt_document_items;
              this.condition_mismatch_items = this.condition_mismatch_items.map((item, index) => ({
                ...item,
                id: index + 1,
                ...(item.claim_details && item.claim_details.length > 0
                  ? { is_expanded: true }
                  : { is_crm_duplicate: false })
              }));
            }else{
              this.condition_mismatch_items = response.data.inventory
            }
          } else {
            this.showAlert("error", "No Data Found");
          }
        })
        .catch(error => {
          this.showAlert("error", "Something went wrong from Network" + error);
          this.loading = false;
        });
      },
      openModal(url) {
        this.modalImageUrl = url;
        this.imagePopup = true;
      },
      extractFileName(url) {
        return url.split('/').pop();
      },
      itemDetails(item){
        const itemId = item.id
        this.item_id = itemId
        this.resolutionItemDetailPopup = true
        this.$httpSecured
        .get(`/api/v1/warehouse/pending_for_resolution/${itemId}`)
        .then(response => {
          if (response.data) {
            this.view_details = response.data.inventory
            this.loading = false;
          } else {
            this.loading = false;
            this.showAlert("error", "No Data Found");
          }
        })
        .catch(error => {
          this.showAlert("error", "Something went wrong from Network" + error);
          this.loading = false;
        });
      },
      handlePageSizeChange(size){
        this.pageSize = size;
          this.page = 1
          if (this.active_tab === "Insurance Claim For Short Items") {
            this.InsuranceClaimShortITems()
          } else if(this.active_tab === "For Short Quantity Received"){
            this.getShortQuantityReceived()
          } if (this.active_tab === "Pending For Resolution") {
            this.pendingForResolution();
          } else if(this.active_tab === "Condition Mismatch"){
            this.conditionMismatch();
          } if (this.active_tab === "Logistic Damage") {
            this.logisticMismatch();
          } else if(this.active_tab === "Against E-com Market Places"){
            this.EcomMarketPlace();
          } else if(this.active_tab === "Write Off Items"){
            this.getWriteOffItems();  
          }else if(this.active_tab === "Pending For Approval"){
            this.fetchPendingForApproval();
          }
        },
        handlePageChange(value) {
          this.page = value;
          if (this.active_tab === "Insurance Claim For Short Items") {
            this.InsuranceClaimShortITems()
          } else if(this.active_tab === "For Short Quantity Received"){
            this.getShortQuantityReceived()
          } if (this.active_tab === "Pending For Resolution") {
            this.pendingForResolution();
          } else if(this.active_tab === "Condition Mismatch"){
            this.conditionMismatch();
          } if (this.active_tab === "Logistic Damage") {
            this.logisticMismatch();
          } else if(this.active_tab === "Against E-com Market Places"){
            this.EcomMarketPlace(); 
          }else if(this.active_tab === "Write Off Items"){
            this.getWriteOffItems(); 
          }else if(this.active_tab === "Pending For Approval"){
            this.fetchPendingForApproval();
          }
        },
        showAlert(alert_type, alert_message) {
          this.alert = true;
          this.alert_type = alert_type;
          this.alert_message = alert_message;
          this.alertTimeOut();
        },
        alertTimeOut() {
          setTimeout(() => {
            this.alert = false;
          }, 3000);
        },
      getVendorList(){
        this.loading = true;
        this.$httpSecured
          .get('api/v2/vendor_masters/logistics_vendors')
          .then(response => {
              if (response.data) {
                this.update_vendor_items = response.data.vendor_codes
                this.loading = false;
              } else {
                this.showAlert("error", "No Data Found");
                this.loading = false;
              }
          })
          .catch(error => {
              this.showAlert("error", "Something went wrong from Network" + error);
              this.loading = false;
          });
      },
      createNewClaimPopup(){
         this.RaiseNewClaimPopup = true;
         this.tagInvalid = false;
         this.seacrh_tag = '';
         this.tagValidationMessage = ''
         this.tagValidationMessage1 = ''
         this.number = 0;
      },
      validateTag(){
        if(this.seacrh_tag.length > 1){
          this.$httpSecured
          .get(`/api/v1/warehouse/condition_mismatch/validate_tag_number?tag_number=${this.seacrh_tag}`)
          .then(response => {
              if (response.data) {
                if(response.data.message === 'Tag Number not present'){
                  this.tagInvalid = true;
                  this.tagValidationMessage = response.data.message;
                  this.tagValidationMessage1 = ''
                }else{
                  this.tagInvalid = false;
                  this.tagValidationMessage = '';
                  this.tagValidationMessage1 = response.data.message;
                } 
              }else {
                this.showAlert("error", "No Data Found");
              }
          })
          .catch(error => {
              this.showAlert("error", error.response.data.error);
          });
        }else{
          this.tagValidationMessage = '';
          this.tagValidationMessage1 = '';
        }
        
      },
      createNewRequest(){
        this.number++;
        this.$httpSecured
          .post('/api/v1/warehouse/condition_mismatch/create_mismatch_items', {
            "tag_number": this.seacrh_tag
          })
          .then(response => {
              if (response.data) {
                // this.$toast.success(response.data.message);
                this.RaiseNewClaimPopup = false;
                this.message = response.data.message
                this.successPopup = true                 
                this.loading = false;
                this.number = 0;
              } else {
                this.showAlert("error", "No Data Found");
                this.loading = false;
                this.number = 0;
              }
          })
          .catch(error => {
              this.showAlert("error", error.response.data.error);
              this.loading = false;
              this.number = 0;
          });
      },
    formatReverseDate(dateString) {
      if (!dateString) return '-';
      const [year, month, day] = dateString.split('-');
      return `${day}-${month}-${year}`;
    },
    }
  }
</script>
<style scoped>
  .disabled {
      pointer-events: none;
      color: gray;
    }
    .itemDetailHeader{
      padding: 10px 0px;
      color: #777873;
      line-height: 17px;
      font-weight: 700;
    }
    .ItemDetailContent{
      color: #c3c3c3;
      font-size: 14px;
      font-weight: 600;
    }
    .editRemarks{
      color: #1976d2;
      font-size: 14px;
      margin-left: 6px;
      cursor: pointer;
      text-decoration: underline;
    }
    .itemIDS{
      font-size: 14px;
      color: #c3c3c3;
    }
    .item-selected{
      margin-top: 23px;
      position: absolute;
      left: 41%;
    }
    .image-container {
      display: flex;
      float: left;
      padding: 6px;
      margin-right: 10px;
      box-shadow: 0px 5px 8px 0px #c3c3c3;
    }
    .image-view{
      width: 74px;
      height: 74px;
    }
    .v-data-table {
      height: calc(var(--vh, 1vh) * 100 - 355px) !important;
    }
    .v-data-simple-adjust {
      box-shadow: none !important;
    }
    :deep(.v-data-simple-adjust .v-data-table) {
      height: auto !important;
      max-height: none !important;
    }
    .disabled-tab {
      color: #b0b0b0;
      pointer-events: none;
      cursor: not-allowed;
    }
</style>